import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_3 = { class: "mt-3 text-sm text-gray-600" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4 rounded-xl bg-teal-50 p-3 text-sm text-teal-800"
}
const _hoisted_5 = { class: "mt-6 flex flex-wrap justify-center gap-3" }

import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { LockClosedIcon } from '@heroicons/vue/24/outline';
import usePaidAccess, { PaidFeature } from '@/store/paidAccess';
import useAuthStore from '@/store/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaidFeatureGate',
  props: {
    feature: {},
    contextKey: { default: '' },
    contentClass: { default: '' }
  },
  emits: ['allowed'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { t } = useI18n();
const route = useRoute();
const access = usePaidAccess();
const auth = useAuthStore();
const state = computed(() => access.states[props.feature]);
const hasLoaded = ref(false);

async function verify() {
  if (await access.check(props.feature)) {
    hasLoaded.value = true;
    emit('allowed');
  }
}

watch(() => [props.feature, props.contextKey, auth.session.uuid], () => {
  hasLoaded.value = false;
  verify();
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", null, [
    (state.value !== 'allowed')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mx-auto my-8 max-w-2xl rounded-2xl bg-white p-6 text-center shadow-sm ring-2 ring-teal-100 sm:p-8",
          role: "status",
          "aria-busy": state.value === 'checking'
        }, [
          _createVNode(_unref(LockClosedIcon), { class: "mx-auto mb-4 h-12 w-12 rounded-xl bg-teal-50 p-3 text-teal-600" }),
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)(`paidFeatures.titles.${state.value === 'subscriptionRequired' ? _ctx.feature : state.value}`)), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)(`paidFeatures.descriptions.${state.value === 'subscriptionRequired' ? _ctx.feature : state.value}`)), 1),
          (state.value === 'subscriptionRequired')
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(t)('paidFeatures.creditsExplanation')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            (state.value === 'subscriptionRequired')
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: { name: 'PricingPage' },
                  class: "rounded-lg bg-teal-600 px-5 py-3 text-sm font-semibold text-white hover:bg-teal-700"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('paidFeatures.viewPlans')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (state.value === 'unauthorized')
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 1,
                  to: { name: 'SessionLoginPage', query: { redirect: _unref(route).fullPath } },
                  class: "rounded-lg bg-teal-600 px-5 py-3 text-sm font-semibold text-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('paidFeatures.signIn')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (state.value !== 'checking')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "rounded-lg border border-gray-200 px-5 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50",
                  onClick: verify
                }, _toDisplayString(_unref(t)(state.value === 'subscriptionRequired'
            ? 'paidFeatures.checkAgain' : 'paidFeatures.retry')), 1))
              : _createCommentVNode("", true)
          ])
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (hasLoaded.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(_ctx.contentClass)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)), [
          [_vShow, state.value === 'allowed']
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})